(function () {
    'use strict';

    angular
        .module('oddQuestionnaireTemplateModule')
        .directive('oddQuestionMultipleLabels', directive);

    directive.$inject = [];

    function directive() {
        return {
            restrict: 'E',
            scope: {
                question: '=',
                isDisabled: '=',
                labelListChanged: '&?onLabelListChange'
            },
            require: ['^form'],
            templateUrl: require('./oddQuestionMultipleLabels.tpl.html'),
            link: function ($scope, $element, $attrs, $ctrl) {
                $scope.form = $ctrl[0];
                $scope.validate();
            },
            controller: ['$rootScope', '$scope', '$timeout', function ($rootScope, $scope, $timeout) {
                $scope.add = add;
                $scope.remove = remove;
                $scope.validate = validate;

                function validate() {
                    var isValid = !!($scope.question.ODDQuestionLabels && $scope.question.ODDQuestionLabels.length >= 1);

                    $scope.form.$setValidity('ODDQuestionLabel', isValid);
                }

                function add() {
                    if (!$scope.question.ODDQuestionLabels) {
                        $scope.question.ODDQuestionLabels = [];
                    }

                    $scope.question.ODDQuestionLabels.push({});

                    $scope.form.$setDirty();
                    validate();

                    $timeout(function() {
                        $scope.$broadcast('focus.label.' + ($scope.question.ODDQuestionLabels.length - 1));
                    });
                    $scope.labelListChanged();
                }

                function remove(index) {
                    $scope.question.ODDQuestionLabels.splice(index, 1);

                    $scope.form.$setDirty();
                    validate();
                    $scope.labelListChanged();
                }
            }]
        }
    }
})();